import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { findKey, map, omitBy, startCase, toLower, isEmpty, isNull, isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
import { toaster } from 'Helpers/toaster';
import errorHandler from 'Utils/error-handler';

import { Alert, Input, Col, Row, Button, Form, Select, Space, Divider } from 'antd';
import {
    AlertBox,
    Button as ButtonCustom,
    SelectInput,
    TextInput,
    PhoneInput
} from '@life-line-lab/components-react';

import './support.scss';

let recaptchaToken = "";

const Support = () => {
    
    const { Option } = Select;
    const MAX_LIMIT = 1000;

    const history = useHistory();
    const { t } = useTranslation();

    const initialInput = {
        firstName: '',
        lastName: '',
        name: '',
        company: '',
        mobileNumber: { dialCode: '', number: '' },
        emailAddress: '',
        message: '',
        typeEnquiry: '',
        orderNumber: ''
    }

    const [input, setInput] = useState<any>(initialInput);
    const [error, setError] = useState<any>({});
    const [state, setState] = useState<any>({ successMessage: null, errorMessage: null });

    let [count, setCount] = useState<any>(0);

    const nl2br = (str: any, isXhtml: any) => {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }

        var breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    const onChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (e.target.name === 'message' && e.target.value.length >= 1001) { return; }

        setError({});
        setState({ ...state, successMessage: null, errorMessage: null });

        if (e.target.name === 'message') {
            const value = e.target.value;
            value.slice(0, MAX_LIMIT)

            let length = value?.length || 0;
            setCount(length);
            setInput({ ...input, [e.target.name]: value });
        }
        else {
            setInput({ ...input, [e.target.name]: e.target.value });
        }
    }

    const handlePhoneChange = (value: { dialCode: string, number: string }, name: string) => {
        setError({});
        value = !isNil(value) ? value : { dialCode: '60', number: '' };
        setInput({ ...input, [name]: value });
    }
    useEffect(() => {
        // Add reCaptcha
            const script = document.createElement("script")
            script.src = `${process.env.RECAPTCHA_API_URL}?render=${process.env.RECAPTCHA_SITE_KEY}`
            // script.addEventListener("load", handleLoaded)
            document.body.appendChild(script)
        }, [])

    const onSubmit = async (e: any) => {
        e.preventDefault();
        delete input.name;

        const validate = onValidate();

        if (validate && (!input.name || input.name?.length == 0)) {
            window.grecaptcha.ready(_ => {
                window.grecaptcha
                  .execute(process.env.RECAPTCHA_SITE_KEY, { action: "onSubmit" })
                  .then(async(responseToken) => {
                    recaptchaToken = responseToken
                    
                    const data = omitBy({
                        firstName: input.firstName,
                        lastName: input.lastName,
                        emailAddress: input.emailAddress,
                        company: input.company,
                        enquiry: input.typeEnquiry,
                        phoneNumber: (input.mobileNumber?.dialCode || '') + (input.mobileNumber?.number || ''),
                        message: input.message,
                        orderNumber: input.orderNumber,
                        recaptchaToken: recaptchaToken,
                        recaptchaSite: process.env.ACCOUNT_TYPE
                        }, o => isNull(o) || o.trim() === '')
                      
                    setState({ ...state, isLoading: true });
        
                    try{
                        const url = `${process.env.API_URL}/${process.env.API_VER}/dem/mail/send/customer`;
                        const res = await axios({
                            method: 'POST',
                            url: url,
                            data: data
                        });
                    
                        if (res?.data?.send) {
                            setState({ ...state, isLoading: false });
                            setInput(initialInput);
                            setError({});
            
                            toaster(
                                'success',
                                <div dangerouslySetInnerHTML={{
                                    __html: t('toaster.supportSuccess')
                                }} />
                            );
                            history.push('/');
                        }else{
                            setState({ ...state, isLoading: false });
                            toaster('error', t('toaster.supportFailed'));
                        }
                    }catch(err){
                        setState({ ...state, isLoading: false });
                        toaster('error', t('toaster.supportFailed'));

                        const { error } = err.response?.data || {};
                        if (!isEmpty(error)) {
                        const { value, code, message, stack } = await errorHandler.response(error);
                        return { error: { value, code, message, stack }};
                        }
                        else {
                        console.log(err.message)
                        return { error: { message: err.message }};
                        }
                    }
                  })
            })
        }
        
    }
    

    const onValidate = () => {
        let targetName: any;

        map(input, (_, target) => {
            if (input[target] === '' && target !== 'company' && target !== 'name' && target !== 'orderNumber') {
                if (target === 'firstName') {
                    targetName = t('label.support.firstName');
                }
                else if (target === 'lastName') {
                    targetName = t('label.support.lastName');
                }
                else if (target === 'mobileNumber') {
                    targetName = t('label.support.mobileNumber');
                }
                else if (target === 'typeEnquiry') {
                    targetName = t('label.support.enquiry');
                }
                else if (target === 'emailAddress') {
                    targetName = t('label.support.emailAddress');
                }
                else if (target === 'message') {
                    targetName = t('label.support.message');
                }
                else {
                    targetName = target;
                }

                error[target] = `${t('error.required', { field: targetName })}`;
            }
            else {
                const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (target === 'emailAddress' && !emailRegex.test(input[target])) {
                    error[target] = `${t('error.pattern', { field: t('label.support.emailAddress') })}`;
                }

                const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
                if (target === 'mobileNumber' && !phoneRegex.test((input[target]?.dialCode || '') + (input[target]?.number || ''))) {
                    error[target] = `${t('error.pattern', { field: t('label.support.mobileNumber') })}`;
                }
            }
        });

        if (!isEmpty(omitBy(error, isNull))) {
            setError({ ...error });
            const target = findKey(error);

            if (document.querySelector(`input[name=${target}]`)) {
                (document.querySelector(`input[name=${target}]`) as HTMLInputElement).focus();
            }

            return false;
        }
        else
            return true;
    }

    return (
        <div className="support-page page">
            <div className="page--container">
                <Helmet>
                    <title>{t('pageTitle.support')}</title>
                </Helmet>

                {/* <Space direction="vertical" size="small" align="center">
                    <h1>DrEzy Sdn Bhd</h1>
                    <h3 className="center">
                        64-3, Jalan 27/70a, Desa Sri Hartamas, 50480 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur
                    </h3>
                </Space>
                
                <Divider/> */}

                <h1 className="support-page--form-title mt-20">
                    {t('label.support.supportForm')}
                </h1>

                <Form layout="vertical" className="mt-40">
                    <Row gutter={[20, 16]}>
                        <Col span={24}>
                            <SelectInput
                                label={t('label.support.enquiry')}
                                value={input.typeEnquiry}
                                onChange={(value) => { setError({}); setInput({ ...input, typeEnquiry: value }) }}
                                size="middle"
                                options={[
                                    { label: 'Account', value: 'Account' },
                                    { label: 'Order', value: 'Order' },
                                    { label: 'Shipping', value: 'Shipping' },
                                    { label: 'Payment', value: 'Payment' },
                                    { label: 'Return & Exchange', value: 'Return & Exchange' },
                                    { label: 'Refund', value: 'Refund' },
                                ]}
                                isError={error.typeEnquiry}
                                isRequired={true}
                            />
                            <AlertBox text={error.typeEnquiry} type="error" />
                        </Col>
                    </Row>

                    <Row gutter={[20, 16]} style={{ marginTop: 20 }}>
                        <Col span={24}>
                            <TextInput
                                name="firstName"
                                size="middle"
                                onChange={onChange}
                                value={input.firstName}
                                label={t('label.support.firstName')}
                                isError={error.firstName}
                                isRequired={true}
                            />
                            <AlertBox text={error.firstName} type="error" />
                        </Col>

                        <Col span={24}>
                            <TextInput
                                name="lastName"
                                size="middle"
                                onChange={onChange}
                                value={input.lastName}
                                label={t('label.support.lastName')}
                                isError={error.lastName}
                                isRequired={true}
                            />
                            <AlertBox text={error.lastName} type="error" />
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                            {/* <TextInput
                            name="mobileNumber"
                            size="middle"
                            onChange={onChange}
                            label={t('label.support.mobileNumber')}
                            value={input.mobileNumber}
                            isError={error.mobileNumber}
                            isRequired={true}
                        />
                        <AlertBox text={error.mobileNumber} type="error" /> */}
                            <PhoneInput
                                isRequired={true}
                                isError={error.mobileNumber}
                                label={t('label.support.mobileNumber')}
                                // preferredCountries={['MY']}
                                name="mobileNumber"
                                value={input.mobileNumber}
                                onChange={(value) => handlePhoneChange(value, 'mobileNumber')}
                            />
                            <AlertBox text={error.mobileNumber} />
                        </Col>

                        <Col span={24}>
                            <TextInput
                                name="company"
                                size="middle"
                                onChange={onChange}
                                value={input.company}
                                label={t('label.support.company')}
                                isError={error.company}
                            />
                            <AlertBox text={error.company} type="error" />
                        </Col>

                        <Col span={24}>
                            <TextInput
                                name="emailAddress"
                                size="middle"
                                onChange={onChange}
                                label={t('label.support.emailAddress')}
                                isError={error.emailAddress}
                                value={input.emailAddress}
                                isRequired={true}
                            />
                            <AlertBox text={error.emailAddress} type="error" />
                        </Col>

                        <Col span={24}>
                            <TextInput
                                name="orderNumber"
                                size="middle"
                                onChange={onChange}
                                label={t('label.orderNumber')}
                                isError={error.orderNumber}
                                value={input.orderNumber}
                            />
                            <AlertBox text={error.orderNumber} type="error" />
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                requiredMark={true}
                                required={true}
                                style={{
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.02rem',
                                    marginBottom: -1
                                }}
                                label={t('label.support.message')}
                            >
                                <Input.TextArea
                                    id="message"
                                    name="message"
                                    size="middle"
                                    value={input.message}
                                    onChange={onChange}
                                    style={{
                                        border: error.message ? '1px solid red' : undefined
                                    }}
                                    rows={10}
                                    required={true}
                                    maxLength={MAX_LIMIT}
                                />
                            </Form.Item>

                            <small className="mt-5 right">
                                {`${input.message.length} / 1000` || ''}
                            </small>

                            <AlertBox text={error.message} type="error" />
                        </Col>

                        <Col span={24} style={{ textAlign: 'left' }}>
                            <ButtonCustom
                                type="primary"
                                size="large"
                                label={t('label.support.send')}
                                onClick={onSubmit}
                                isLoading={state.isLoading}
                            />

                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    )
}

export default Support;
